<div class="dvb-firma-kontingent-value-title">
   <span data-translate="{{vm.title}}"
         data-translate-value-preposition="{{vm.preposition | translate}}"></span>
    <span ng-bind="vm.firmenKontingentValue.gueltigAb | amDateFormat: 'D.M.YYYY'"></span>
</div>
